<template>
  <v-app id="inspire">
    <NavBar />
    <v-main>
      <SideBar />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import SideBar from '@/components/SideBar.vue';
export default {
  name: 'TelaHome',
  components: {
    NavBar,
    SideBar,
  },
};
</script>
<style scoped>
#inspire {
  background-color: #f9f8f8;
}
</style>
